import React, { useEffect, useState } from "react";
import { getStrategicImpactAPI } from "../../service/ai.service";
import { getEvaluationPayload } from "../../service/storage.service";
import { useAppContext } from "../../context/app.context";
import { NavigationButton } from "../intro/objective";
import { useNavigate } from "react-router-dom";
import { DisabledNavLink } from "../../component/sidemenu";
import { SECTION_NAMES } from "../../helper/constant";

const StrategicImpact = () => {
    const { aiMaturityEval, getAIMaturityEvaluation, updateLoader } = useAppContext();
    const [aiImpact, setAiImpact] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!aiMaturityEval) {
            getAIMaturityEvaluation();
        }
        if (aiMaturityEval) {
            updateLoader(true);
            const payload = getEvaluationPayload(aiMaturityEval);
            getStrategicImpactAPI(payload).then(response => {
                setAiImpact(response);
            }).catch(error => {
                console.error("Error fetching AI Value Data:", error);
            }).finally(() => updateLoader(false));;
        }
        return () => { }
    }, [aiMaturityEval]);

    const rendrerImpact = () => {
        if (aiImpact && aiImpact.strategic_loss) {
            return aiImpact.strategic_loss.map((item, index) => (
                <div className="col-md-3 mb-3" key={index}>
                    <div className="h-100 border p-3 text-center">
                        <div>❗</div>
                        {item.description}
                    </div>
                </div>
            ));
        }
        return <div>No strategic impact data available.</div>;
    }

    const renderImpactTable = () => {
        if (aiImpact && aiImpact.impact) {
            return (
                <table className="table table-bordered">
                    <thead className="thead-light">
                        <tr>
                            <th>Profit Loss Area</th>
                            <th>Annual Impact (Est.)</th>
                            <th>How 360Business.AI Fixes It</th>
                        </tr>
                    </thead>
                    <tbody>
                        {aiImpact.impact.map((item, index) => <tr>
                            <td><i className="icon">📉</i> {item.name}</td>
                            <td>{item.annual_impact}</td>
                            <td>{item.fix}</td>
                        </tr>)
                        }
                    </tbody>
                </table>
            )
        }
    }
    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <h3 className=" text-blue h4 mb-3 mb-0">{SECTION_NAMES.STRATEGIC_IMPLICATIONS}</h3>
                <div className="d-flex align-items-center gap-4">
                    <DisabledNavLink to='/ai-value'><i class="fa fa-angle-left" style={{ fontSize: 32 }} aria-hidden="true"></i><p className="m-0 p-0">{SECTION_NAMES.AI_VALUE}</p></DisabledNavLink>
                    <DisabledNavLink to='/ai-roadmap'><p className="m-0 p-0">{SECTION_NAMES.AI_ROADMAP}</p><i class="fa fa-angle-right" aria-hidden="true" style={{ fontSize: 32 }} ></i></DisabledNavLink>
                </div>
            </div>
            <div className="strategicimplicationsslider1 navigatorslider1 px-5">
                <div>
                    <div className=" mt-3 mb-2"><strong>The Cost of Inaction (What You Lose)</strong></div>
                    <div>Without 360Business.AI, your business risks:</div>

                    <div className="row mt-4">
                        {rendrerImpact()}
                    </div>
                </div>
                <div className="mt-5">
                    {renderImpactTable()}
                </div>
                {/* <div style={{ textAlign: "center" }}>
                    <button className="slick-arrow slick-prev slick-prev-page" onClick={() => navigate('/ai-value')}></button>
                    <button className={`slick-arrow slick-next slick-next-page`} onClick={() => navigate('/ai-roadmap')}></button>
                </div> */}
            </div>
        </>
    );
};

export default StrategicImpact;
